import AgreementType from 'components/blocks/Delta/Inputs/AgreementType';
import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import Province from 'components/blocks/Delta/Inputs/Province';
import TestCommunity from 'components/blocks/Delta/Inputs/TestCommunity';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import FormInputIPF from 'components/blocks/ManagementNewForms/Inputs/FormInputIPF'; import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import { opacity } from 'html2canvas/dist/types/css/property-descriptors/opacity';
import React, { useEffect, useState } from 'react'
import { FormProvider, set, useFieldArray, useForm } from 'react-hook-form';
import get from 'lodash/get';
import FormInputTable from 'components/blocks/ManagementNewForms/Inputs/FormInputTable';
import Loader from 'components/blocks/Loader/Loader';
import useCreatetCertificadoEmpresaIt from 'services/record/CertificadoEmpresa/useCreateCertificadoEmpresaIt';
import useUpdateCertificadoEmpresaItByID from 'services/record/CertificadoEmpresa/useUpdateCertificadoEmpresaItByID';
import FormInputRadioTable from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputRadioTable';
import AccordionDisplay from 'components/blocks/ManagementNewForms/Accordion/AccordionDisplay';
import FormInputRadioGroup from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputRadioGroup';
import TextAreaDefault from 'components/blocks/ManagementNewForms/TextArea/TextAreaDefault';
import FormDoubleInput from 'components/blocks/ManagementNewForms/Inputs/FormDoubleInput';
import FormInputCheckboxTable from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputCheckBoxTable';
import FormArrayArchivosReducidos, { adaptDocumentacion, prepareDocumentacionArrayWithCase } from 'components/blocks/ManagementNewForms/ButtonGroups/ArrayInputArchivo';
import useCreateDeclaracionJuradaCeseActividadObjetiva from 'services/record/DeclaracionJuradaCeseActividadObjetiva/useCreateDeclaracionJuradaCeseActividadObjetiva';
import useUpdateDeclaracionJuradaCeseActividadObjetivaByID from 'services/record/DeclaracionJuradaCeseActividadObjetiva/useUpdateDeclaracionJuradaCeseActividadObjetiva';
import InputTextIntegration from 'components/blocks/ManagementNewForms/Inputs/InputTextIntegration';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';
import ProgressBarBattery from 'components/ProgressBarBattery/ProgressBarBattery';


const DeclaracionJuradaCeseActividadObjetiva = ({ info, dataUser, onSuccess }: { info: boolean; dataUser: any, onSuccess?: () => void }) => {


    const formMethods = useForm();
    const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;
    const { createDeclaracionJuradaCeseActividadObjetiva, dataCreateDeclaracionJuradaCeseActividadObjetiva, errorCreateDeclaracionJuradaCeseActividadObjetiva, loadingCreateDeclaracionJuradaCeseActividadObjetiva, successCreateDeclaracionJuradaCeseActividadObjetiva } = useCreateDeclaracionJuradaCeseActividadObjetiva();
    const { dataUpdateDeclaracionJuradaCeseActividadObjetivaById, errorUpdateDeclaracionJuradaCeseActividadObjetivaById, loadingUpdateDeclaracionJuradaCeseActividadObjetivaById, successUpdateDeclaracionJuradaCeseActividadObjetivaById, updateDeclaracionJuradaCeseActividadObjetivaById } = useUpdateDeclaracionJuradaCeseActividadObjetivaByID();
    const [datosAPI, setDatosAPI] = useState(dataUser);
    const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
    const [loader, setLoader] = useState(false);
    const [totalSize, setTotalSize] = useState(0);
    const MAX_SIZE_MB = 30;
    const INGRESOS_FIELDS = [
        'IngresosExplotacion',
        'OtrosIngresos',
        'AutoConsumoBienesServicios'
    ];

    const GASTOS_FIELDS = [
        'ConsumosExplotacion',
        'SueldosSalarios',
        'SeguridadSocialEmpresa',
        'OtrosGastosPersonal',
        'ArrendamientosCanones',
        'ReparacionesConservacion',
        'ServiciosProfesionalesIndependientes',
        'OtrosServiciosExteriores',
        'Tributos',
        'GastosFinancieros',
        'Amortizaciones',
        'OtrosGastosDificilJustificacion'
    ];



    const sumColumn = (fields: string[], column: 0 | 1): number => {
        return fields.reduce((acc, field) => {
            const value = watch(`${field}.${column}`);
            const num = typeof value === 'number' ? value : parseFloat(value);
            return acc + (isNaN(num) ? 0 : num);
        }, 0);
    };

    const parseDecimal = (value: any): number => {
        if (value == null || value === '') return 0;
        const normalizedValue = value.toString().replace(',', '.');
        const parsedValue = parseFloat(normalizedValue);
        return isNaN(parsedValue) ? 0 : parsedValue;
    };

    useEffect(() => {
        // Totales ingresos
        const totalIngresos0 = sumColumn(INGRESOS_FIELDS, 0);
        const totalIngresos1 = sumColumn(INGRESOS_FIELDS, 1);

        setValue('TotalIngresosComputables.0', totalIngresos0);
        setValue('TotalIngresosComputables.1', totalIngresos1);

        // Totales gastos
        const totalGastos0 = sumColumn(GASTOS_FIELDS, 0);
        const totalGastos1 = sumColumn(GASTOS_FIELDS, 1);
        console.log(totalGastos0, totalGastos1)
        setValue('TotalGastosDevengados.0', totalGastos0);
        setValue('TotalGastosDevengados.1', totalGastos1);

        // Rendimiento neto
        const rendimiento0 = totalIngresos0 - totalGastos0;
        const rendimiento1 = totalIngresos1 - totalGastos1;

        setValue('IngresosIntegros.0', rendimiento0);
        setValue('IngresosIntegros.1', rendimiento1);

        // Porcentaje rendimiento neto
        const porcentaje0 =
            totalIngresos0 !== 0 ? (rendimiento0 / totalIngresos0) * 100 : 0;
        const porcentaje1 =
            totalIngresos1 !== 0 ? (rendimiento1 / totalIngresos1) * 100 : 0;

        setValue('PorcentajeRendimientoNeto.0', Number(porcentaje0.toFixed(2)));
        setValue('PorcentajeRendimientoNeto.1', Number(porcentaje1.toFixed(2)));

    }, [
        // INGRESOS
        watch('IngresosExplotacion.0'),
        watch('IngresosExplotacion.1'),
        watch('OtrosIngresos.0'),
        watch('OtrosIngresos.1'),
        watch('AutoConsumoBienesServicios.0'),
        watch('AutoConsumoBienesServicios.1'),

        // GASTOS
        watch('ConsumosExplotacion.0'),
        watch('ConsumosExplotacion.1'),
        watch('SueldosSalarios.0'),
        watch('SueldosSalarios.1'),
        watch('SeguridadSocialEmpresa.0'),
        watch('SeguridadSocialEmpresa.1'),
        watch('OtrosGastosPersonal.0'),
        watch('OtrosGastosPersonal.1'),
        watch('ArrendamientosCanones.0'),
        watch('ArrendamientosCanones.1'),
        watch('ReparacionesConservacion.0'),
        watch('ReparacionesConservacion.1'),
        watch('ServiciosProfesionalesIndependientes.0'),
        watch('ServiciosProfesionalesIndependientes.1'),
        watch('OtrosServiciosExteriores.0'),
        watch('OtrosServiciosExteriores.1'),
        watch('Tributos.0'),
        watch('Tributos.1'),
        watch('GastosFinancieros.0'),
        watch('GastosFinancieros.1'),
        watch('Amortizaciones.0'),
        watch('Amortizaciones.1'),
        watch('OtrosGastosDificilJustificacion.0'),
        watch('OtrosGastosDificilJustificacion.1')
    ]);

    useEffect(() => {
        const ingreso = parseDecimal(watch('CeseActividad.EjecucionJudicialIngreso'));
        const importeEjecuciones = parseDecimal(watch('CeseActividad.EjecucionJudicialImporteEjecuciones'));
        const porcentaje = ingreso > 0 ? (importeEjecuciones * 100) / ingreso : 0;

        setValue('CeseActividad.EjecucionJudicialPorcentaje', Number(porcentaje.toFixed(2)));
    }, [
        watch('CeseActividad.EjecucionJudicialIngreso'),
        watch('CeseActividad.EjecucionJudicialImporteEjecuciones')
    ]);





    const adaptApiResponseToDefaultValues = (data: any) => {
        if (!data) return;

        const economicos = Array.isArray(data?.DatosEconomicosCeseActividad)
            ? data.DatosEconomicosCeseActividad
            : [];

        const getEco = (index: number, field: string, defaultValue: any) =>
            economicos[index]?.[field] ?? defaultValue;

        reset({
            // =====================================================
            // DATOS PERSONALES
            // =====================================================
            DatosPersonales: {
                SolicitanteNombre: data?.DatosPersonales?.Nombre || "",
                SolicitanteApellido1: data?.DatosPersonales?.Apellido1 || "",
                SolicitanteApellido2: data?.DatosPersonales?.Apellido2 || "",
                SolicitanteIPF: data?.DatosPersonales?.IPF || "",
                SolicitanteIPFTipo: data?.DatosPersonales?.IPFTipo?.toString() || "1",
                SolicitanteComunidadCodigo: data?.DatosPersonales?.ComunidadCodigo || "",
                SolicitanteTelefono: data?.DatosPersonales?.Telefono || "",
                SolicitanteFijo: data?.DatosPersonales?.Fijo || "",
                SolicitanteDomicilio: data?.DatosPersonales?.Domicilio || "",
                SolicitanteCodigoPostal: data?.DatosPersonales?.CodigoPostal || "",
                SolicitanteProvincia: data?.DatosPersonales?.CodigoProvincia || "",
                SolicitanteProvinciaDescripcion: data?.DatosPersonales?.Provincia || "",
                SolicitanteNumeroSS: data?.DatosPersonales?.NumeroSeguridadSocial || "",
                SolicitanteNombreCompleto: data?.DatosPersonales?.Nombre + " " + data?.DatosPersonales?.Apellido1 + " " + data?.DatosPersonales?.Apellido2 || "",
            },

            // =====================================================
            // CESE ACTIVIDAD
            // =====================================================
            CeseActividad: {
                DeclaracionCese: data?.MotivoCeseActividad ?? false,

                TipoMotivoCese:
                    data?.TipoMotivoCeseActividad != null
                        ? data.TipoMotivoCeseActividad.toString()
                        : null,

                FechaMotivoCese: data?.FechaMotivoCese || null,

                EstablecimientoMercantil:
                    data?.TitularEstablecimiento ?? false,

                DomicilioEstablecimiento:
                    data?.DomicilioEstablecimiento || "",

                TecnicosProductivosOrganizativos:
                    data?.TecnicosProductivosOrganizativos || "",

                EjecucionJudicialIngreso:
                    data?.EjecucionesCobroDeudas?.ImporteTotalIngresos?.toString() || "",

                EjecucionJudicialImporteEjecuciones:
                    data?.EjecucionesCobroDeudas?.ImporteTotalEjecuciones?.toString() || "",

                EjecucionJudicialPorcentaje:
                    data?.EjecucionesCobroDeudas?.PorcentajeEjecucionesSobreIngresos?.toString() || ""
            },

            DatosEconomicosCeseActividad: {
                Id: [
                    getEco(0, "Id", "")?.toString() || "",
                    getEco(1, "Id", "")?.toString() || ""
                ]
            },
            // =====================================================
            // DOCUMENTACION
            // =====================================================
            Documentacion: adaptDocumentacion(data?.SeccionesDocumentacion),
            // =====================================================
            // ARRAYS ECONÓMICOS 
            // =====================================================
            Ejercicio: [
                getEco(0, "Ejercicio", null),
                getEco(1, "Ejercicio", null)
            ],

            EpigrafeIAE: [
                getEco(0, "GrupoIAE", ""),
                getEco(1, "GrupoIAE", "")
            ],

            IngresosExplotacion: [
                getEco(0, "IngresosExplotacion", "").toString(),
                getEco(1, "IngresosExplotacion", "").toString()
            ],

            OtrosIngresos: [
                getEco(0, "OtrosIngresos", "").toString(),
                getEco(1, "OtrosIngresos", "").toString()
            ],

            AutoConsumoBienesServicios: [
                getEco(0, "Autoconsumo", "").toString(),
                getEco(1, "Autoconsumo", "").toString()
            ],

            TotalIngresosComputables: [
                getEco(0, "TotalIngresos", 0),
                getEco(1, "TotalIngresos", 0)
            ],

            ConsumosExplotacion: [
                getEco(0, "ConsumosExplotacion", "").toString(),
                getEco(1, "ConsumosExplotacion", "").toString()
            ],

            SueldosSalarios: [
                getEco(0, "SueldosSalarios", "").toString(),
                getEco(1, "SueldosSalarios", "").toString()
            ],

            SeguridadSocialEmpresa: [
                getEco(0, "SeguridadSocialEmpresa", "").toString(),
                getEco(1, "SeguridadSocialEmpresa", "").toString()
            ],

            OtrosGastosPersonal: [
                getEco(0, "OtrosGastosPersonal", "").toString(),
                getEco(1, "OtrosGastosPersonal", "").toString()
            ],

            ArrendamientosCanones: [
                getEco(0, "ArrendamientosCanones", "").toString(),
                getEco(1, "ArrendamientosCanones", "").toString()
            ],

            ReparacionesConservacion: [
                getEco(0, "ReparacionesConservacion", "").toString(),
                getEco(1, "ReparacionesConservacion", "").toString()
            ],

            ServiciosProfesionalesIndependientes: [
                getEco(0, "ServiciosProfesionalesIndependientes", "").toString(),
                getEco(1, "ServiciosProfesionalesIndependientes", "").toString()
            ],

            OtrosServiciosExteriores: [
                getEco(0, "OtrosServiciosExteriores", "").toString(),
                getEco(1, "OtrosServiciosExteriores", "").toString()
            ],

            Tributos: [
                getEco(0, "Tributos", "").toString(),
                getEco(1, "Tributos", "").toString()
            ],

            GastosFinancieros: [
                getEco(0, "GastosFinancieros", "").toString(),
                getEco(1, "GastosFinancieros", "").toString()
            ],

            Amortizaciones: [
                getEco(0, "AmortizacionesDotaciones", "").toString(),
                getEco(1, "AmortizacionesDotaciones", "").toString()
            ],

            OtrosGastosDificilJustificacion: [
                getEco(0, "OtrosGastosJustificacion", "").toString(),
                getEco(1, "OtrosGastosJustificacion", "").toString()
            ],

            TotalGastosDevengados: [
                getEco(0, "TotalGastos", 0),
                getEco(1, "TotalGastos", 0)
            ],

            IngresosIntegros: [
                getEco(0, "RendimientoNeto", 0),
                getEco(1, "RendimientoNeto", 0)
            ],

            PorcentajeRendimientoNeto: [
                getEco(0, "PorcentajeRendimientoNeto", 0),
                getEco(1, "PorcentajeRendimientoNeto", 0)
            ],

        });
    };


    useEffect(() => {
        setDatosAPI(dataUser);
    }, [dataUser]);

    useEffect(() => {
        adaptApiResponseToDefaultValues(dataUser);
    }, [dataUser]);




    const onSubmit = async (data: any) => {
        console.log(data);
        setLoader(true);

        const toNumber = (v: any) =>
            v !== "" && v != null && !isNaN(v) ? Number(v) : 0;
        const toNullableString = (v: any) => (v === "" || v == null ? null : v);

        const datosEconomicosCeseActividad = [0, 1].map(index => ({
            id:
                toNullableString(data?.DatosEconomicosCeseActividad?.Id?.[index]) ??
                data?.datosEconomicosCeseActividad?.[index]?.Id ??
                null,
            externalId: data?.datosEconomicosCeseActividad?.[index]?.ExternalId ?? 0,
            formularioSDeclaracionJuradaObjetivaId: data?.datosEconomicosCeseActividad?.[index]?.FormularioSDeclaracionJuradaObjetivaId ?? null,

            ejercicio: data?.Ejercicio?.[index] ?? 0,
            grupoIAE: data?.EpigrafeIAE?.[index] || "",

            ingresosExplotacion: toNumber(data?.IngresosExplotacion?.[index]),
            otrosIngresos: toNumber(data?.OtrosIngresos?.[index]),
            autoconsumo: toNumber(data?.AutoConsumoBienesServicios?.[index]),
            totalIngresos: data?.TotalIngresosComputables?.[index] ?? 0,

            consumosExplotacion: toNumber(data?.ConsumosExplotacion?.[index]),
            sueldosSalarios: toNumber(data?.SueldosSalarios?.[index]),
            seguridadSocialEmpresa: toNumber(data?.SeguridadSocialEmpresa?.[index]),
            otrosGastosPersonal: toNumber(data?.OtrosGastosPersonal?.[index]),
            arrendamientosCanones: toNumber(data?.ArrendamientosCanones?.[index]),
            reparacionesConservacion: toNumber(data?.ReparacionesConservacion?.[index]),
            ServiciosProfesionalesIndependientes: toNumber(data?.ServiciosProfesionalesIndependientes?.[index]),
            otrosServiciosExteriores: toNumber(data?.OtrosServiciosExteriores?.[index]),
            tributos: toNumber(data?.Tributos?.[index]),
            gastosFinancieros: toNumber(data?.GastosFinancieros?.[index]),
            amortizacionesDotaciones: toNumber(data?.Amortizaciones?.[index]),
            OtrosGastosDificilJustificacion: toNumber(data?.OtrosGastosDificilJustificacion?.[index]),

            totalGastos: data?.TotalGastosDevengados?.[index] ?? 0,
            rendimientoNeto: data?.IngresosIntegros?.[index] ?? 0,
            PorcentajeRendimientoNeto: data?.PorcentajeRendimientoNeto?.[index] ?? 0
        }));
        let prestacionId = dataUser?.PrestacionId || null;
        const documentacionArray = await prepareDocumentacionArrayWithCase(data?.Documentacion || []);
        const datosEnvio = {
            Id: dataUser?.Id || null,
            ExternalId: dataUser?.ExternalId || 0,
            PersonaId: dataUser?.PersonaId || 0,
            UsuarioId: dataUser?.UsuarioId || null,
            ExpedienteId: dataUser?.ExpedienteId || null,
            PrestacionId: prestacionId,

            Acepto: data?.Acepto ?? false,

            // =====================================================
            // DATOS PERSONALES
            // =====================================================
            datosPersonales: {
                nombre: dataUser?.DatosPersonales?.Nombre ?? dataUser?.datosPersonales?.nombre ?? "",
                apellido1: dataUser?.DatosPersonales?.Apellido1 ?? dataUser?.datosPersonales?.apellido1 ?? "",
                apellido2: dataUser?.DatosPersonales?.Apellido2 ?? dataUser?.datosPersonales?.apellido2 ?? "",
                ipf: dataUser?.DatosPersonales?.IPF ?? dataUser?.datosPersonales?.ipf ?? "",
                ipfTipo: dataUser?.DatosPersonales?.IPFTipo ?? dataUser?.datosPersonales?.ipfTipo ?? 1,
                telefono: dataUser?.DatosPersonales?.Telefono ?? dataUser?.datosPersonales?.telefono ?? "",
                fijo: dataUser?.DatosPersonales?.Fijo ?? dataUser?.datosPersonales?.fijo ?? "",
                domicilio: dataUser?.DatosPersonales?.Domicilio ?? dataUser?.datosPersonales?.domicilio ?? "",
                codigoPostal: dataUser?.DatosPersonales?.CodigoPostal ?? dataUser?.datosPersonales?.codigoPostal ?? "",
                provinciaDescripcion: dataUser?.DatosPersonales?.ProvinciaDescripcion ?? dataUser?.DatosPersonales?.Provincia ?? dataUser?.datosPersonales?.provinciaDescripcion ?? "",
                codigoProvincia: dataUser?.DatosPersonales?.CodigoProvincia ?? dataUser?.datosPersonales?.codigoProvincia ?? "",
                codigoLocalidad: dataUser?.DatosPersonales?.CodigoLocalidad ?? dataUser?.datosPersonales?.codigoLocalidad ?? "",
                localidadDescripcion: dataUser?.DatosPersonales?.LocalidadDescripcion ?? dataUser?.datosPersonales?.localidadDescripcion ?? "",
                numeroSeguridadSocial: dataUser?.DatosPersonales?.NumeroSeguridadSocial ?? dataUser?.datosPersonales?.numeroSeguridadSocial ?? ""
            },



            // =====================================================
            // CESE ACTIVIDAD
            // =====================================================
            motivoCeseActividad: data?.CeseActividad?.DeclaracionCese ?? false,

            tipoMotivoCeseActividad:
                data?.CeseActividad?.TipoMotivoCese != null
                    ? parseInt(data.CeseActividad.TipoMotivoCese)
                    : null,

            fechaMotivoCese: data?.CeseActividad?.FechaMotivoCese || null,

            titularEstablecimiento:
                data?.CeseActividad?.EstablecimientoMercantil ?? false,

            domicilioEstablecimiento:
                data?.CeseActividad?.DomicilioEstablecimiento || "",

            tecnicosProductivosOrganizativos:
                data?.CeseActividad?.TecnicosProductivosOrganizativos || "",

            ejecucionesCobroDeudas: {
                importeTotalIngresos:
                    toNumber(data?.CeseActividad?.EjecucionJudicialIngreso),
                importeTotalEjecuciones:
                    toNumber(data?.CeseActividad?.EjecucionJudicialImporteEjecuciones),
                porcentajeEjecucionesSobreIngresos:
                    toNumber(data?.CeseActividad?.EjecucionJudicialPorcentaje)
            },

            // =====================================================
            // DATOS ECONÓMICOS
            // =====================================================
            DatosEconomicosCeseActividad: parseInt(data?.CeseActividad?.TipoMotivoCese) != 0 ? null : datosEconomicosCeseActividad,

            // =====================================================
            // DOCUMENTACIÓN
            // =====================================================
            Documentacion: documentacionArray
        };
        console.log(datosEnvio);
        if (info) {
            await createDeclaracionJuradaCeseActividadObjetiva(dataUser?.UsuarioId.toString(), datosEnvio, onSuccess)
            setBloquearEnvio(true);
        } else {
            await updateDeclaracionJuradaCeseActividadObjetivaById(dataUser?.userId, dataUser?.Id, datosEnvio)
            setBloquearEnvio(true);
        }


        setTimeout(() => {
            setLoader(false); //tiempo cargar DOM
        }, 500);
    };





    return (
        <FormProvider {...formMethods}>
            <div className="container form--simple-styled" id="formDeltawithoutleave">

                {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
                <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

                <Loader activeLoader={loader || loadingCreateDeclaracionJuradaCeseActividadObjetiva || loadingUpdateDeclaracionJuradaCeseActividadObjetivaById} label="Cargando Formulario"></Loader>








                {/* ////////////// COMIENZO FORMULARIO ////////////// */}
                {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}
                <FormInfoCreateUpdate
                    isCreate={info}
                    estadoFormulario={datosAPI?.EstadoFormulario ?? datosAPI?.estadoFormulario ?? dataUser?.EstadoFormulario ?? dataUser?.estadoFormulario}
                    estadoFormularioDescripcion={datosAPI?.EstadoFormularioDescripcion ?? datosAPI?.estadoFormularioDescripcion ?? dataUser?.EstadoFormularioDescripcion ?? dataUser?.estadoFormularioDescripcion}
                    fechaActualizacionEstado={datosAPI?.FechaActualizacionEstado ?? datosAPI?.fechaActualizacionEstado ?? dataUser?.FechaActualizacionEstado ?? dataUser?.fechaActualizacionEstado}
                />
                <FieldsetContainer legend="" disabled={false}>
                    <p className=' mb-2 parra-bold'>En virtud de la prescripción recogida en el Título V “protección por cese de actividad” del RD Legislativo 8/2015 de 30 de octubre por el que se
                        aprueba el TRLGSS, en cuyo artículo 332 se determina la forma de acreditación de la situación legal de cese de la actividad en cada uno de los
                        supuestos tasados que se enumeran en el artículo 331 del mismo cuerpo legal, se certifica lo siguiente</p>
                    <p className='mt-2 mb-4 text-left parra-bold'>D./Dña
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteNombreCompleto"
                            inputType={1}
                            disabled={true}
                            minWidth={300}
                        />

                        con número de afiliación a la Seguridad Social
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteNumeroSS"
                            inputType={1}
                            disabled={true}
                        />
                        con DNI/NIF/pasaporte/NIE número
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteIPF"
                            inputType={1}
                            disabled={true}
                        />
                        y domicilio en
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteDomicilio"
                            inputType={1}
                            disabled={true}
                            minWidth={500}
                        />
                        atendiendo a mi declaración anual
                        de IRPF en la modalidad de estimación objetiva, declaro en mi condición de trabajador/a autónomo/a, que he cesado el
                        ejercicio de mi actividad por alguna de esas causas:
                    </p>

                </FieldsetContainer>


                <div className="row mb-4">
                    <div className="col-xl-12">


                        <FieldsetContainer legend="" disabled={false}>

                            <FormInputCheckboxTable
                                title="En su condición de trabajador/a autónomo/a declara que ha cesado el ejercicio de su actividad por alguna de estas causas"
                                names={["CeseActividad.DeclaracionCese"]}
                                required='Debe seleccionar el Motivo del Cese'
                                labels={[
                                    "Pérdidas por motivo económico,tecnico, productivo u organizativos",
                                ]}
                                modal={["Por la concurrencia de motivos económicos, técnicos, productivos u organizativos determinantes de la inviabilidad de proseguir la actividad económica o profesional"]}
                                col={12}
                            />

                            <AccordionDisplay dataUser={dataUser} visibility={watch('CeseActividad.DeclaracionCese') === true} fields={[]}>
                                <FormInputRadioGroup
                                    title=""
                                    name={"CeseActividad.TipoMotivoCese"}
                                    labels={[
                                        "Pérdidas superiores al 10% de los ingresos",
                                        "Motivos técnicos, productivos u organizativos",
                                        "Ejecuciones judiciales o administrativas",
                                        "Declaración judicial de concurso",
                                        "Fallecimiento, jubilación o incapacidad del titular",
                                    ]}
                                    modal={[
                                        "Pérdidas derivadas del ejercicio de su actividad en un año completo superiores al 10% de los ingresos, excluido el primer año de actividad.",
                                        "",
                                        "Ejecuciones judiciales o administrativas tendentes al cobro de deudas reconocidas por los órganos ejecutivos que comporten, al menos, el 30% de los ingresos del ejercicio económico inmediatamente anterior.",
                                        "Declaración judicial de concurso que impida continuar con la actividad, en los términos de la Ley 22/2003, de 9 de julio, Concursal.",
                                        "En el caso de autónomo/a que viniera realizando funciones de ayuda familiar por: muerte, jubilación o incapacidad permanente del cónyuge titular del negocio.",
                                    ]}
                                    col={12}
                                />
                                <div style={{ display: 'none' }}>
                                    <FormDoubleInput
                                        label="IDs datos económicos"
                                        name="DatosEconomicosCeseActividad.Id"
                                        inputTypes={[1, 1]}
                                    />
                                </div>
                                <AccordionDisplay dataUser={dataUser} visibility={watch('CeseActividad.TipoMotivoCese') === '1'} fields={['CeseActividad.TecnicosProductivosOrganizativos']}>
                                    <div className="col-xl-12 col-md-12">
                                        <TextAreaDefault
                                            id='CeseActividad.TecnicosProductivosOrganizativos'
                                            name='CeseActividad.TecnicosProductivosOrganizativos'
                                            label='Técnicos, productivos u organizativos:'
                                            placeholder=""

                                        />
                                    </div>
                                </AccordionDisplay>
                                <AccordionDisplay dataUser={dataUser} visibility={watch('CeseActividad.TipoMotivoCese') === '2'} fields={['CeseActividad.EjecucionJudicialIngreso', 'CeseActividad.EjecucionJudicialImporteEjecuciones', 'CeseActividad.EjecucionJudicialPorcentaje']}>
                                    <FormInputText
                                        name='CeseActividad.EjecucionJudicialIngreso'
                                        id='CeseActividad.EjecucionJudicialIngreso'
                                        label='Ingresos por la actividad (A):'
                                        md={4}
                                        xl={4}
                                        disabled={false}
                                        pattern={/^[0-9]+([.,][0-9]+)?$/}
                                        patternMessage="Introduce un número válido (entero o decimal, con '.' o ',')"
                                    />
                                    <FormInputText
                                        name='CeseActividad.EjecucionJudicialImporteEjecuciones'
                                        id='CeseActividad.EjecucionJudicialImporteEjecuciones'
                                        label='Importe total de las ejecuciones (B):'
                                        md={4}
                                        xl={4}
                                        disabled={false}
                                        pattern={/^[0-9]+([.,][0-9]+)?$/}
                                        patternMessage="Introduce un número válido (entero o decimal, con '.' o ',')"
                                    />
                                    <FormInputText
                                        name='CeseActividad.EjecucionJudicialPorcentaje'
                                        id='CeseActividad.EjecucionJudicialPorcentaje'
                                        label='% Ejecuciones/Ingresos:'
                                        modal='Cálculo: (Importe Total de las Ejecucionesx100)/Ingresos por la actividad'
                                        md={4}
                                        xl={4}
                                        disabled={true}
                                        pattern={/^[0-9]+([.,][0-9]+)?$/}
                                        patternMessage="Introduce un número válido (entero o decimal, con '.' o ',')"
                                    />
                                </AccordionDisplay>



                                <AccordionDisplay dataUser={dataUser} visibility={watch('CeseActividad.TipoMotivoCese') === '0'} fields={["Ejercicio",
                                    "EpigrafeIAE",
                                    "IngresosExplotacion",
                                    "OtrosIngresos",
                                    "AutoConsumoBienesServicios",
                                    "TotalIngresosComputables",
                                    "ConsumosExplotacion",
                                    "SueldosSalarios",
                                    "SeguridadSocialEmpresa",
                                    "OtrosGastosPersonal",
                                    "ArrendamientosCanones",
                                    "ReparacionesConservacion",
                                    "ServiciosProfesionalesIndependientes",
                                    "OtrosServiciosExteriores",
                                    "Tributos",
                                    "GastosFinancieros",
                                    "Amortizaciones",
                                    "OtrosGastosDificilJustificacion",
                                    "TotalGastosDevengados",
                                    "IngresosIntegros",
                                    "PorcentajeRendimientoNeto"]}>


                                    <FormDoubleInput
                                        modal='Los años en los que se han producido las: Actividades económicas realizadas y rendimientos obtenidos'
                                        label="Ejercicio"
                                        name="Ejercicio"
                                        inputTypes={[2, 2]}
                                        required={[ "Requerido añadir el Ejercicio 1", "Requerido añadir el Ejercicio 2"]}
                                    />



                                    <div className={`col-xl-12 col-md-12 align-self-center text-start mt-3 mx-2 fs-5`}>
                                        Actividades Realizadas

                                    </div>
                                    <FormDoubleInput
                                        modal='Grupo o epígrafe I.A.E de la actividad principal en caso de realizarse actividades del mismo grupo. Adjuntar certificado de la Agencia Tributaria sobre el Impuesto de Actividades Económicas'
                                        label="Grupo o epígrafe I.A.E"
                                        name="EpigrafeIAE"
                                        inputTypes={[1, 1]}
                                    />



                                    <div className={`col-xl-12 col-md-12 align-self-center text-start mt-3 mx-2 fs-5`}>
                                        Ingresos íntegros
                                    </div>
                                    <FormDoubleInput
                                        label="Ingresos de explotación"
                                        name="IngresosExplotacion"
                                        inputTypes={[3, 3]}
                                    />
                                    <FormDoubleInput
                                        modal='Incluye subvenciones y otras transferencias'
                                        label="Otros Ingresos"
                                        name="OtrosIngresos"
                                        inputTypes={[3, 3]}
                                    />
                                    <FormDoubleInput
                                        modal=''
                                        label="Autoconsumo de bienes y servicios"
                                        name="AutoConsumoBienesServicios"
                                        inputTypes={[3, 3]}
                                    />
                                    <FormDoubleInput
                                        modal='Suma resultante de los ingresos de explotación, otros ingresos y autoconsumo de bienes y servicios'
                                        label="Total ingresos computables"
                                        name="TotalIngresosComputables"
                                        inputTypes={[3, 3]}
                                        disabled={true}
                                    />



                                    <div className="col-xl-12 col-md-12 align-self-center text-start mt-4 mx-2 fs-5">
                                        Gastos devengados
                                    </div>

                                    <FormDoubleInput
                                        label="Consumos de explotación"
                                        name="ConsumosExplotacion"
                                        inputTypes={[3, 3]}
                                    />

                                    <FormDoubleInput
                                        label="Sueldos y salarios"
                                        name="SueldosSalarios"
                                        inputTypes={[3, 3]}
                                    />

                                    <FormDoubleInput
                                        modal="Incluidas las cotizaciones del titular"
                                        label="Seguridad Social a cargo de la empresa"
                                        name="SeguridadSocialEmpresa"
                                        inputTypes={[3, 3]}
                                    />

                                    <FormDoubleInput
                                        label="Otros gastos de personal"
                                        name="OtrosGastosPersonal"
                                        inputTypes={[3, 3]}
                                    />

                                    <FormDoubleInput
                                        label="Arrendamientos y cánones"
                                        name="ArrendamientosCanones"
                                        inputTypes={[3, 3]}
                                    />

                                    <FormDoubleInput
                                        label="Reparaciones y conservación"
                                        name="ReparacionesConservacion"
                                        inputTypes={[3, 3]}
                                    />

                                    <FormDoubleInput
                                        label="Servicios de profesionales independientes"
                                        name="ServiciosProfesionalesIndependientes"
                                        inputTypes={[3, 3]}
                                    />

                                    <FormDoubleInput
                                        label="Otros servicios exteriores"
                                        name="OtrosServiciosExteriores"
                                        inputTypes={[3, 3]}
                                    />

                                    <FormDoubleInput
                                        label="Tributos"
                                        name="Tributos"
                                        inputTypes={[3, 3]}
                                    />

                                    <FormDoubleInput
                                        label="Gastos financieros"
                                        name="GastosFinancieros"
                                        inputTypes={[3, 3]}
                                    />

                                    <FormDoubleInput
                                        modal=""
                                        label="Amortizaciones, dotaciones del ejercicio"
                                        name="Amortizaciones"
                                        inputTypes={[3, 3]}
                                    />

                                    <FormDoubleInput
                                        label="Otros gastos de difícil justificación"
                                        name="OtrosGastosDificilJustificacion"
                                        inputTypes={[3, 3]}
                                    />

                                    <FormDoubleInput
                                        modal="Suma total de los apartados de Gastos Devengados"
                                        label="Total gastos devengados"
                                        name="TotalGastosDevengados"
                                        inputTypes={[3, 3]}
                                        disabled={true}
                                    />



                                    <div className="col-xl-12 col-md-12 align-self-center text-start mt-4 mx-2 fs-5">
                                        Rendimiento neto
                                    </div>

                                    <FormDoubleInput
                                        modal="El cálculo se realiza mediante la resta de: Ingresos íntegros menos gastos devengados"
                                        label="Ingresos íntegros"
                                        name="IngresosIntegros"
                                        inputTypes={[3, 3]}
                                        disabled={true}
                                    />

                                    <FormDoubleInput
                                        modal="% de rendimiento neto sobre los ingresos (casilla Ingresos Íntegros dividido por casilla 'Total Ingresos computables' multiplicado por 100)."
                                        label="% rendimiento neto sobre ingresos íntegros"
                                        name="PorcentajeRendimientoNeto"
                                        inputTypes={[3, 3]}
                                        disabled={true}
                                    />

                                    <div className='mt-5'>

                                    </div>
                                    <FormArrayArchivosReducidos
                                        name={'Documentacion'}
                                        setTotalSize={setTotalSize}
                                    />


                                    <ProgressBarBattery totalSize={totalSize} maxSize={MAX_SIZE_MB} showProgressBar={true} position="left"></ProgressBarBattery>

                                </AccordionDisplay>
                                <div className='m-4'></div>
                                <p>
                                    Del mismo modo, hace constar que la fecha en la que se ha producido el motivo aducido es:
                                    <InputTextIntegration
                                        name="CeseActividad.FechaMotivoCese"
                                        inputType={4}
                                        disabled={false}
                                        minWidth={150}
                                    />
                                </p>

                                <div className='m-4'></div>

                                <FormInputCheckboxTable
                                    title="Es titular de un establecimiento mercantil, industrial o de otra naturaleza abierto al público"
                                    names={["CeseActividad.EstablecimientoMercantil"]}
                                    labels={[
                                        "Marquese si procede"
                                    ]}
                                    col={12}
                                />





                                <AccordionDisplay dataUser={dataUser} visibility={watch('CeseActividad.EstablecimientoMercantil') === true} fields={['CeseActividad.DomicilioEstablecimiento']}>

                                    <p>
                                        Es titular de un establecimiento mercantil, industrial o de otra naturaleza abierto al público, situado en (indique
                                        dirección completa):
                                        <InputTextIntegration
                                            name="CeseActividad.DomicilioEstablecimiento"
                                            inputType={1}
                                            disabled={false}
                                            minWidth={300}
                                        />
                                        el cual permanecerá cerrado durante todo el período en
                                        el que perciba prestación económica por cese de actividad.
                                    </p>
                                </AccordionDisplay>


                            </AccordionDisplay>

                        </FieldsetContainer>
                    </div>
                </div>

















                {/* ////////////// FINAL FORMULARIO ////////////// */}


                {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
                <FormBotonSubmit
                    disableSubmit={bloquearEnvio}
                    onSubmit={handleSubmit(onSubmit)}
                    successCreate={successCreateDeclaracionJuradaCeseActividadObjetiva}
                    successUpdate={successUpdateDeclaracionJuradaCeseActividadObjetivaById}
                    errorCreate={errorCreateDeclaracionJuradaCeseActividadObjetiva}
                    errorUpdate={errorUpdateDeclaracionJuradaCeseActividadObjetivaById}
                    datosAPI={datosAPI}
                    info={info}
                    BloqueoForm={[1]}
                    totalSizeDocs={totalSize}
                    MaxSizeMB={MAX_SIZE_MB}
                    label='Declara bajo su responsabilidad que son ciertos los datos que se consignan en la presente declaración y que, al día de la fecha, los datos declarados siguen siendo vigentes, informándose que, en caso de resultar inciertos, la Mutua se reserva el derecho de reclamación de la prestación a que hubiera dado lugar'
                />


                <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
                    Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
                    que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
                    fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
                </p>

                <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
                    En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
                    personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
                    cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
                    podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
                    escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
                    debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
                </p>



            </div>
        </FormProvider>
    )
}

export default DeclaracionJuradaCeseActividadObjetiva
